export default "__VITE_ASSET__CJrSAykm__"